import { useEffect } from "react";

export function useBootstrapDirection(lang, { i18n }) {
    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        document.title = lang === "ar" ? "مسار التميز" : "Masar Altmaioz";
        const linkElement = document.getElementById("bootstrap-dynamic-css");
        if (linkElement) {
            linkElement.href = lang === "ar"
                ? "/css/bootstrap.rtl.min.css"
                : "/css/bootstrap.min.css";
        }
        // If the current route includes AdminLayout, force language to Arabic
        if (window.location.pathname.startsWith("/admin") || window.location.pathname.startsWith("/adminLogin")) {
            if (lang !== "ar") {
                document.documentElement.lang = "ar";
                document.documentElement.dir = "rtl";
                i18n.changeLanguage("ar");
            }
        }
    }, [lang, i18n]);
}